export type PaymentProviderId = 'paypal' | 'stripe';

export const PAYMENT_PROVIDER_RENDER_ORDER: readonly PaymentProviderId[] = [
  'stripe',
  'paypal',
] as const;

export class InvalidPaymentProviderIdError extends Error {
  constructor(value: string | null | undefined) {
    super(`Unsupported payment provider: ${value ?? 'empty'}`);
    this.name = 'InvalidPaymentProviderIdError';
  }
}

export function isPaymentProviderId(
  value: string | null | undefined
): value is PaymentProviderId {
  return value === 'paypal' || value === 'stripe';
}

export function parsePaymentProviderList(
  value: string | null | undefined
): PaymentProviderId[] {
  if (!value) {
    return [];
  }

  const providers: PaymentProviderId[] = [];
  for (const part of value.split(',')) {
    const normalized = part.trim().toLowerCase();
    if (!normalized) {
      continue;
    }

    if (!isPaymentProviderId(normalized)) {
      throw new InvalidPaymentProviderIdError(part);
    }

    if (!providers.includes(normalized)) {
      providers.push(normalized);
    }
  }

  return providers;
}

export function resolveSinglePaymentProvider(
  value: string | null | undefined
): PaymentProviderId | null {
  const normalized = value?.trim().toLowerCase();
  if (!normalized) {
    return null;
  }

  if (!isPaymentProviderId(normalized)) {
    throw new InvalidPaymentProviderIdError(value);
  }

  return normalized;
}
